export const sanitizarNombre = (valor: string): string => {
    return valor
        .replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, "")
        .replace(/\s+/g, " ")
        .trimStart();
};

export const sanitizarCorreo = (valor: string): string => {
    return valor
        .toLowerCase()
        .replace(/\s/g, "")
        .replace(/[^a-z0-9@._-]/g, "");
};

export const validarCorreo = (correo: string): boolean => {
    const regex =
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

    return regex.test(correo);
};

export const validarNombre = (nombre: string): boolean => {
    return nombre.trim().length >= 3;
};

export const sanitizarNombrePerfil = (
    valor: string
): string => {

    return valor
        .toUpperCase()
        .replace(/\s+/g, "")
        .replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ0-9_-]/g, "");

};

export const sanitizarDescripcionPerfil = (
    valor: string
): string => {

    return valor
        .replace(/[<>{}[\]$%`\\|^~]/g, "")
        .replace(/\s+/g, " ")
        .trimStart();

};

export const validarNombrePerfil = (
    nombre: string
): boolean => {

    return nombre.trim().length >= 3;

};

export const validarDescripcionPerfil = (
    descripcion: string
): boolean => {

    return descripcion.trim().length >= 3;

};

export const sanitizarNombrePermiso = (
    valor: string
): string => {

    return valor
        .toLowerCase()
        .replace(/\s+/g, "_")
        .replace(/[^a-z0-9_]/g, "");

};